import React from "react";
import "./style.scss";
const Title = ({ label, className }) => {
  return <h3 className={`title ${className}`}>{label}</h3>;
};

export default Title;
